import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import mutations from './mutations'
import getters from './getters'
import state from './state'
import createLogger from 'vuex/dist/logger'
Vue.use(Vuex);

const debug = process.env.NODE_ENV !=='production';
export default new Vuex.Store({
  actions,
  mutations,
  getters,
  state,
  strict:debug,
  plugins:debug?[createLogger()]:[]
})


// WEBPACK FOOTER //
// ./src/store/index.js